import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/casos-de-estudio/")({
  head: () => buildRouteHead("/es/casos-de-estudio/", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/casos-de-exito", replace: true });
  },
});
